export const smallScreen = 'focus_test_mode:small_screen';
export const bigScreen = 'focus_test_mode:big_screen';
export const offline = 'focus_test_mode:offline';
